{
  "language": {
    "title": "Choose your language",
    "en": "English",
    "en_US": "English",
    "nl": "Nederlands",
    "sr": "Srpski",
    "fr": "Français",
    "de": "Deutsch",
    "pt": "Português",
    "es": "Español",
    "ja": "日本語",
    "pl": "Polski",
    "it": "Italiano"
  },
  "home": {
    "welcomeMessage": "Hi, how can we help you?",
    "checkIn": "Check in",
    "independentManualCheckIn": "No appointment",
    "integratedManualCheckIn": "Check in manually",
    "checkOut": "Check out",
    "manualCheckOut": "Check out manually",
    "parcelDelivery": "Parcel delivery",
    "foodDelivery": "Food delivery",
    "callReception": "Call reception",
    "overview": "Overview",
    "unavailable": "The reception is currently unavailable."
  },
  "check": {
    "option": {
      "checkin": {
        "title": "Choose an option to check in",
        "manual": "Check in manually",
        "code": "Check in with PIN or QR code",
        "code-no-qr": "Check in with PIN code"
      },
      "checkout": {
        "title": "Choose an option to check out",
        "manual": "Check out with name",
        "code": "Check out with PIN or QR code",
        "code-no-qr": "Check out with PIN code"
      }
    },
    "title": "You can now scan your QR code or enter your PIN code.",
    "orText": "Or",
    "qrScanner": {
      "checkin": {
        "title": "Choose an option to check in"
      },
      "checkout": {
        "title": "Choose an option to check out"
      },
      "btn": "Scan your QR code"
    },
    "hidScanner": {
      "title": "Hold QR code to the scanner below or enter your PIN code"
    },
    "pinOnly": {
      "title": "Please enter your PIN code"
    },
    "pinCode": "Enter your PIN code",
    "manually": {
      "checkin": "Don't have a checkin code?"
    },
    "status": {
      "idle": {
        "title": "Your code is scanning.",
        "message": "Please wait...",
        "nfc": {
          "title": "Your tag is scanning.",
          "message": "Please wait..."
        }
      },
      "loading": {
        "title": "Your code is scanning.",
        "message": "Please wait...",
        "nfc": {
          "title": "Your tag is scanning.",
          "message": "Please wait..."
        }
      },
      "error": {
        "title": "Your code is invalid.",
        "message": "Please try again!",
        "nfc": {
          "title": "Your tag is invalid.",
          "message": "Please try again!"
        },
        "meeting": {
          "tooEarly": {
            "title": "You're a bit early",
            "message": "Your code is valid from {{validFromTime}}. The meeting starts at {{meetingStartTime}}."
          },
          "tooLate": {
            "title": "This code has expired",
            "message": "The meeting ended at {{meetingEndTime}}. Your code was valid until {{validUntilTime}}."
          }
        }
      },
      "success": {
        "checkin": {
          "default": {
            "title": "You have successfully checked in.",
            "message": "Thank you."
          },
          "MeetingAttendee": {
            "no-email-sms": {
              "title": "You have successfully checked in.",
              "message": "Thank you."
            },
            "email-sms": {
              "title": "You have successfully checked in.",
              "message": "Your contact person has been notified."
            },
            "call-ping": {
              "title": "You have successfully checked in.",
              "message": "We will now establish a phone call with your contact person."
            },
            "teams-call": {
              "title": "You have successfully checked in.",
              "message": "We will now establish a Microsoft Teams call with your contact person."
            },
            "badge": {
              "title": "Thank you for checking in, your badge will be printed.",
              "message": ""
            },
            "video-call": {
              "title": "You have successfully checked in.",
              "message": "Setting up your video call with the contact person."
            }
          },
          "Employee": {
            "title": "You have successfully checked in.",
            "message": "Thank you.",
            "badge": {
              "title": "Thank you for checking in, your badge will be printed.",
              "message": ""
            }
          },
          "Visitor": {
            "title": "You have successfully checked in.",
            "message": "Thank you.",
            "badge": {
              "title": "Thank you for checking in, your badge will be printed.",
              "message": ""
            }
          }
        },
        "checkout": {
          "default": {
            "title": "You have successfully checked out.<br/>",
            "message": "See you again soon."
          },
          "MeetingAttendee": {
            "title": "You have successfully checked out.",
            "message": "See you again soon."
          },
          "Employee": {
            "title": "You have successfully checked out.",
            "message": "See you again soon."
          },
          "Visitor": {
            "title": "You have successfully checked out.",
            "message": "See you again soon."
          },
          "access": {
            "title": "You have successfully checked out.",
            "message": "You can now open the door."
          }
        }
      }
    }
  },
  "missingFields": {
    "title": "A few more details before check-in",
    "subtitle": "Fields marked * are required",
    "btn": "Check in",
    "placeholder": {
      "other": "Other...",
      "otherInput": "Enter your option"
    },
    "error": {
      "required": "You didn't fill in this field",
      "email": "Invalid email address",
      "phone": "Invalid phone number"
    }
  },
  "manualCheckin": {
    "title": {
      "default": "Please fill in.",
      "documentScanner": "Pay attention when inserting your identity card:"
    },
    "subtitle": {
      "default": "Note - every field * is required",
      "documentScanner": [
        {
          "parts": [
            { "text": "The side with the ", "bold": false },
            { "text": "<<< >>> characters (MRZ)", "bold": true },
            { "text": ", must be ", "bold": false },
            { "text": "facing the kiosk or scanner.", "bold": true }
          ]
        },
        {
          "parts": [
            { "text": "Hold the card still ", "bold": false },
            {
              "text": "until the fields are filled in automatically.",
              "bold": true
            }
          ]
        }
      ]
    },
    "noOption": "No option",
    "btn": "Check in",
    "placeholder": {
      "name": "Your name *",
      "email": "Your e-mail *",
      "phone": "Mobile number",
      "contactName": "Your contact person*",
      "other": "Other..."
    },
    "error": {
      "required": "You didn't fill in this field",
      "name": "Invalid name",
      "email": "Invalid email address",
      "phone": "Invalid mobile number"
    },
    "status": {
      "idle": {
        "no-contact": {
          "title": "Please wait...",
          "message": "Your registration is being processed."
        },
        "contact": {
          "title": "Please wait...",
          "message": "Your contact is being notified."
        }
      },
      "loading": {
        "no-contact": {
          "title": "Please wait...",
          "message": "Your registration is being processed."
        },
        "contact": {
          "title": "Please wait...",
          "message": "Your contact is being notified."
        }
      },
      "success": {
        "no-email-sms": {
          "title": "You have successfully checked in.",
          "message": "Thank you."
        },
        "email-sms": {
          "title": "You have successfully checked in.",
          "message": "Your contact person is notified."
        },
        "call-ping": {
          "title": "You have successfully checked in.",
          "message": "We will now establish a phone call with your contact person."
        },
        "teams-call": {
          "title": "You have successfully checked in.",
          "message": " We will now establish a Microsoft Teams call with your contact person "
        },
        "badge": {
          "title": "Thank you for checking in, your badge will be printed.",
          "message": ""
        },
        "video-call": {
          "title": "You have successfully checked in.",
          "message": "Setting up your video call with the contact person."
        }
      },
      "error": {
        "title": "Something went wrong.",
        "message": "Please try again!"
      }
    },
    "documentScan": {
      "invalid": {
        "title": "Document not valid",
        "message": "The document could not be verified or has expired. Please enter your details manually."
      }
    }
  },
  "manualCheckout": {
    "title": "Enter your name to check out",
    "btn": "Check out",
    "form": {
      "placeholder": {
        "name": "Your full name *"
      },
      "loading": "Loading...",
      "noOptions": "No options"
    },
    "error": {
      "required": "You didn't fill in this field",
      "name": "Invalid name"
    },
    "status": {
      "idle": {
        "title": "We are processing your information.",
        "message": "Please wait..."
      },
      "loading": {
        "title": "We are processing your information.",
        "message": "Please wait..."
      },
      "success": {
        "title": "You have successfully checked out.",
        "message": "Thank you and have a nice day."
      },
      "successAccess": {
        "title": "You have successfully checked out.",
        "message": "Now you can open the door."
      },
      "error": {
        "title": "An error occurred while checking out.",
        "message": "Please try again!"
      }
    }
  },
  "call": {
    "title": {
      "no-email-sms": "Would you like to notify your contact?",
      "email-sms": "We have sent an email/sms to your contact.<br/>Do you want to establish a call with them additionally?"
    },
    "callBtn": "Call",
    "pingBtn": "Ping",
    "smsBtn": "SMS",
    "callVideoBtn": "Video call",
    "teamsCallBtn": "Teams call",
    "teamsMessageBtn": "Teams message",
    "googleChatMessageBtn": "Google Chat",
    "noBtn": "Cancel",
    "cancelBtn": "Cancel call",
    "status": {
      "connecting": {
        "title": "Establishing call.<br/>Please wait...",
        "message": ""
      },
      "ringing": {
        "title": "Calling your contact person<br/>Please wait...",
        "message": ""
      },
      "ringingReception": {
        "title": "Call started...",
        "message": ""
      },
      "open": {
        "title": "Call in progress.",
        "message": ""
      },
      "close": {
        "title": "Call ended.<br/>",
        "message": ""
      },
      "closeAccess": {
        "title": "Call ended.<br/>Now you can open the door.",
        "message": ""
      },
      "closeReception": {
        "title": "Call is ended.",
        "message": ""
      },
      "error": {
        "title": "Call is not established.<br/>Call again?",
        "message": ""
      }
    }
  },
  "message": {
    "status": {
      "idle": {
        "title": "We are notifying your contact person.",
        "message": "Please wait..."
      },
      "loading": {
        "title": "We are notifying your contact person.",
        "message": "Please wait..."
      },
      "success": {
        "title": "SMS has been sent. The contact has been notified.",
        "message": "Thank you!"
      },
      "successAccess": {
        "title": " SMS has been sent. The contact has been notified. ",
        "message": "Now you can open the door."
      },
      "error": {
        "title": "SMS not sent.",
        "message": "Please try again!"
      }
    }
  },
  "videoCall": {
    "title": "Video call",
    "endCall": "End call",
    "status": {
      "idle": {
        "title": "We are creating a video room.",
        "message": "Please wait..."
      },
      "loading": {
        "title": "We are creating a video room.",
        "message": "Please wait..."
      },
      "success": {
        "title": "The video room has been successfully created.",
        "message": "Joining room..."
      },
      "error": {
        "title": "The video room was not created successfully.",
        "message": "Please try again!"
      }
    }
  },
  "teamsCall": {
    "title": "Teams call",
    "controls": {
      "startCall": "Start call",
      "endCall": "Leave",
      "camera": "Camera",
      "cameraOff": "Camera off",
      "mic": "Mic",
      "micOff": "Mic off",
      "ringing": "Ringing...",
      "noAnswer": "No one has answered the call."
    },
    "status": {
      "connecting": {
        "title": "Establishing call.<br/>Please wait...",
        "message": ""
      },
      "ringing": {
        "title": "Calling your contact person<br/>Please wait...",
        "message": ""
      },
      "connected": {
        "title": "Establishing call",
        "message": ""
      },
      "disconnected": {
        "title": "Call ended.<br/>",
        "message": ""
      },
      "disconnectedAccess": {
        "title": "Call ended.<br/>Now you can open the door.",
        "message": ""
      },
      "error": {
        "title": "Call is not established.<br/>Please try again",
        "message": ""
      },
      "noAnswer": {
        "title": "No one answered the call.<br/>Please try again.",
        "message": ""
      }
    }
  },
  "teamsMessage": {
    "status": {
      "idle": {
        "title": "We are notifying your contact person.",
        "message": "Please wait..."
      },
      "loading": {
        "title": " We are notifying your contact person. ",
        "message": "Please wait..."
      },
      "success": {
        "title": "Message has been sent. The contact has been notified.",
        "message": "Thank you!"
      },
      "successAccess": {
        "title": " Message has been sent. The contact has been notified. ",
        "message": "Now you can open the door."
      },
      "error": {
        "title": "Message not sent.",
        "message": "Please try again!"
      }
    }
  },
  "googleChatMessage": {
    "status": {
      "idle": {
        "title": "We are notifying your contact person.",
        "message": "Please wait..."
      },
      "loading": {
        "title": " We are notifying your contact person. ",
        "message": "Please wait..."
      },
      "success": {
        "title": "Message has been sent. The contact has been notified.",
        "message": "Thank you!"
      },
      "successAccess": {
        "title": " Message has been sent. The contact has been notified. ",
        "message": "Now you can open the door."
      },
      "error": {
        "title": "Message not sent.",
        "message": "Please try again!"
      }
    }
  },
  "packageDelivery": {
    "title": "How nice of you to deliver a package!",
    "subtitle": "Select and notify the recipient",
    "subtitle1": "Press the button below to let us know you are here! ",
    "subtitle2": "",
    "input": {
      "label": {
        "contact": "Who is the parcel for"
      },
      "error": {
        "contact": {
          "required": "You didn't fill in this field"
        }
      }
    },
    "button": {
      "submit": "Notify"
    },
    "status": {
      "loading": {
        "title": "We are notifying the contact person.",
        "message": "Please wait..."
      },
      "success": {
        "no-email-sms": {
          "title": "Thank you for your delivery!",
          "message": ""
        },
        "email-sms": {
          "title": "The contact person has been notified.",
          "message": "Thank you for your delivery!"
        },
        "call-ping": {
          "title": "Thank you for your delivery!",
          "message": "A telephone connection will now be made to the contact person."
        },
        "teams-call": {
          "title": "Thank you for your delivery!",
          "message": "A Microsoft Teams call will now be made to your contact person."
        },
        "video-call": {
          "title": "Thank you for your delivery!",
          "message": "Setting up your video call with the contact person."
        }
      },
      "error": {
        "title": "Something went wrong.",
        "message": "Please try again!"
      }
    }
  },
  "foodDelivery": {
    "title": "How nice of you to deliver food!",
    "subtitle": "Select and notify the recipient",
    "subtitle1": "Press the button below to let us know you are here! ",
    "subtitle2": "",
    "input": {
      "label": {
        "contact": "Who is the food for"
      },
      "error": {
        "contact": {
          "required": "You didn't fill in this field"
        }
      }
    },
    "button": {
      "submit": "Notify"
    },
    "status": {
      "loading": {
        "title": "We are notifying the contact.",
        "message": "Please wait!"
      },
      "success": {
        "no-email-sms": {
          "title": "Thank you for your delivery!",
          "message": ""
        },
        "email-sms": {
          "title": "The contact is notified.",
          "message": "Thank you for your delivery!"
        },
        "call-ping": {
          "title": "Thank you for your delivery!",
          "message": "A telephone connection will now be made to your contact person."
        },
        "teams-call": {
          "title": "Thank you for your delivery!",
          "message": "A Microsoft Teams call will now be made to your contact person."
        },
        "video-call": {
          "title": "Thank you for your delivery!",
          "message": "Setting up your video call with the contact person."
        }
      },
      "error": {
        "title": "Something went wrong.",
        "message": "Please try again!"
      }
    }
  },
  "QRCodeScanner": {
    "title": "Please scan your QR code",
    "subtitle": "Line up the QR code inside the red corners and keep your phone steady.",
    "error": "Invalid QR code format",
    "unknownError": "Unknown error occurred while scanning"
  },
  "common": {
    "backBtn": "Back"
  },
  "previewPDF": {
    "page": {
      "of": "of",
      "previous": "Previous",
      "next": "Next"
    },
    "button": {
      "cancel": "Cancel",
      "accept": "Accept",
      "next": "Next"
    },
    "title": {
      "consent": "Consent required"
    }
  },
  "offline": {
    "title": "Offline",
    "receptionMessage": "The digital reception is offline at the moment and can not be used, the internet connection must be checked!",
    "check": "Are you a visitor and do you want to speak to an employee directly? Please call {{receptionistPhone}}"
  },
  "overview": {
    "title": "Enter the code to open the overview!",
    "noUsers": "No registrations",
    "status": {
      "success": {
        "title": "The code is valid.",
        "message": ""
      },
      "error": {
        "title": "The code invalid.",
        "message": "Please try again!"
      }
    },
    "checkoutStatus": {
      "loading": {
        "title": "Please wait...",
        "message": ""
      },
      "success": {
        "title": "Successful check out.",
        "message": ""
      },
      "error": {
        "title": "Something went wrong.",
        "message": "Please try again!"
      }
    },
    "listTitle": "List of persons who checked in today but didn't check out",
    "page": "Page ",
    "table": {
      "head": {
        "fullName": "Name",
        "type": "Type",
        "checkedinAt": "Checked in at",
        "host": "Host"
      },
      "type": {
        "Package": "Package delivery",
        "Food": "Food delivery",
        "Visitor": "Visitor",
        "MeetingAttendee": "Invited visitor",
        "Employee": "Employee",
        "Guest": "Visitor"
      }
    },
    "confirmModal": {
      "title": "Are you sure you want to check out {{fullName}}?",
      "cancel": "Cancel",
      "checkout": "Check out"
    }
  },
  "wifi": {
    "title": "Connect to the Wi-Fi network"
  },
  "door": {
    "external": {
      "title": "Opening the door",
      "subtitle": "The door will open shortly. Please wait..."
    },
    "control": {
      "title": "You can now open the door",
      "subtitle": "Please press the button below!",
      "openBtn": "Open the door"
    },
    "status": {
      "success": {
        "title": "The door has been opened",
        "message": ""
      },
      "error": {
        "title": "Something went wrong",
        "message": "Please contact your contact person to open the door."
      },
      "loading": {
        "title": "Opening the door...",
        "message": ""
      }
    }
  },
  "photo": {
    "title": "Would you like to take a photo as part of your check-in process?",
    "required": {
      "title": "Photo Verification Required!",
      "instructions": "Please stand in front of the camera and follow the on-screen instructions.",
      "securityNotice": "For security and verification purposes, a photo is required during check-in.",
      "privacyInfo": "We respect your privacy. Your data is securely stored and used only for identification.",
      "closingMessage": "Thank you for your cooperation."
    },
    "optional": {
      "title": "Would you like to take a photo as part of your check-in process?",
      "instructions": "",
      "securityNotice": "Taking a photo can help streamline identification and enhance security.",
      "privacyInfo": "We respect your privacy. This step is optional, and your data will be securely handled.",
      "closingMessage": "You can skip this step if you prefer."
    },
    "subtitle": "Please position yourself within the frame and remain still for the best result",
    "button": {
      "cancel": "Cancel",
      "accept": "Accept",
      "skip": "Skip",
      "next": "Next",
      "recapture": "Recapture photo",
      "continue": "Continue"
    },
    "error": "An error occurred while capturing the photo. The check-in process will continue without the photo."
  },
  "wayfinding": {
    "title": "Where would you like to go?"
  },
  "callingMenu": {
    "title": "Calling menu"
  },
  "bell": {
    "status": {
      "success": {
        "title": "The bell is ringing",
        "message": "Someone will be with you shortly."
      },
      "error": {
        "title": "Something went wrong",
        "message": "Please try again"
      },
      "loading": {
        "title": "Connecting...",
        "message": "Please wait"
      }
    }
  },
  "access": {
    "control": {
      "title": "You can now open the door",
      "subtitle": "Please press the button below.",
      "titleAuto": "Automated door access",
      "subtitleAuto": "The door will open for you automatically",
      "openBtn": "Open"
    },
    "status": {
      "success": {
        "title": "The door has been opened",
        "message": ""
      },
      "error": {
        "title": "Something went wrong",
        "message": "Please contact your contact person to open the door."
      },
      "loading": {
        "title": "Opening the door...",
        "message": ""
      }
    }
  }
}
